






import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {}
})
export default class PersonalUseTime extends ViewBase {
  @Prop({ default: null }) personalUseTime!: any

  lang: any = {}

  echartSource: any = {}

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }
  setSource() {
    const personalUseTime = this.personalUseTime
    const arr = []
    const textArr = []
    const index = 0
    for (const key of Object.keys(personalUseTime)) {
      // echarts绘制对象
      const obj: any = {}
      obj.product = personalUseTime[key].k_name
      obj.points_use_time = personalUseTime[key].points_use_time
      obj.avg_points_use_time = personalUseTime[key].avg_points_use_time
      arr.push(obj)
      this.echartSource = arr
    }
    this.setUseTime()
  }

  // 各考点用时统计
  setUseTime() {
    const that = this
    const myChart = echarts.init(this.$refs.useTime)
    const option = {
      legend: {
        x: 'center'
      },
      tooltip: {},
      dataset: {
        dimensions: ['product', 'points_use_time', 'avg_points_use_time'],
        source: that.echartSource
      },
      xAxis: {
        type: 'category',
        name: that.lang.xAxisText,
        nameLocation: 'center',
        nameTextStyle: { padding: 10 }
      },
      yAxis: { name: that.lang.minute, nameLocation: 'end' },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          barGap: 0,
          name: that.lang.personalTime,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#5B9BD5'
            }
          }
        },
        {
          name: that.lang.averageClassTime,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#ED7D31'
            }
          }
        }
      ]
    }

    // 绘制图表
    myChart.setOption(option)
  }

  created() {
    this.lang = this.i18n.vStudy
    setTimeout(() => {
      this.setSource()
    })
  }
}
